// src/router/layoutRoutes.ts
import { RouteRecordRaw } from 'vue-router';
import MainLayout from '@/components/MainLayout.vue';
import UserDashboard from '@/components/pages/dashboard/index.vue';
import PersonalSetting from '@/components/pages/personalsetting/index.vue';
import MntCompany from '@/components/pages/mnt-system/mnt-company/index.vue';
import MntSite from '@/components/pages/mnt-system/mnt-site/index.vue';
import MntUsers from '@/components/pages/mnt-system/mnt-users/index.vue';
import MntEnv from '@/components/pages/mnt-system/mnt-env/index.vue';
import MntOperators from '@/components/pages/mnt-system/mnt-operators/index.vue';
import MntSensors from '@/components/pages/mnt-system/mnt-sensors/index.vue';
import OperatorDetail from '@/components/pages/detail/index.vue';
import { ROUTES } from '@/config/constants';

const layoutRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: MainLayout,
        children: [
            {   // ダッシュボード
                path: ROUTES.DASHBOARD,
                name: 'UserDashboard',
                component: UserDashboard,
                meta: { requiresAuth: true }
            },
            {   // 詳細情報
                path: `${ROUTES.OPERATOR_DETAIL}/:site_code/:operator_code`,
                name: 'OperatorDetail',
                component: OperatorDetail,
                meta: { requiresAuth: true,
                    requiresParams: ['site_code','operator_code']
                 }
            },
            {   // 契約会社管理
                path: ROUTES.MNT_COMPANY,
                name: 'MntCompany',
                component: MntCompany,
                meta: { requiresAuth: true }
            },
            {   // 現場管理
                path: ROUTES.MNT_SITE,
                name: 'MntSite',
                component: MntSite,
                meta: { requiresAuth: true }
            },
            {   // 安全責任者管理
                path: ROUTES.MNT_USER,
                name: 'MntUser',
                component: MntUsers,
                meta: { requiresAuth: true }
            },
            {   // 操作員（端末）参照
                path: ROUTES.MNT_OPERATOR,
                name: 'MntOperator',
                component: MntOperators,
                meta: { requiresAuth: true }
            },
            {   // センサー管理
                path: ROUTES.MNT_SENSOR,
                name: 'MntSensor',
                component: MntSensors,
                meta: { requiresAuth: true }
            },
            {   // 環境設定
                path: ROUTES.ENV_SETTINGS,
                name: 'MntEnv',
                component: MntEnv,
                meta: { requiresAuth: true }
            },
            {   // 個人設定
                path: ROUTES.PERSONAL_SETTINGS,
                name: 'PersonalSetting',
                component: PersonalSetting,
                meta: { requiresAuth: true }
            }
        ]
    }
];

export default layoutRoutes;